export const VERIFY_CONTEXT = "verify-api";

export const VERIFY_SERVER = "https://verify.walletconnect.com";
